import React, { useState } from "react";
import Header from "./Header";
import Input from "./Input";
import { options } from "../utils/data";

const AddReview = ({ getBook }) => {
  const [terms, setTerms] = useState({
    title: "",
    comment: "",
    score: "5star",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(terms.title);
    console.log(terms.comment);
    console.log("score", terms.score);

    let book = {
      title: terms.title,
      comment: terms.comment,
      score: terms.score.slice(0, 1),
    };

    getBook(book);

    setTerms({
      title: "",
      comment: "",
      score: "5star",
    });
  };

  const handleChange = (name) => (e) => {
    setTerms({ ...terms, [name]: e.target.value });
  };

  return (
    <section>
      <Header title="신규 리뷰 등록" />
      <form>
        <Input
          smallTitle="영화 제목"
          placeholder="제목을 입력해 주세요"
          value={terms.title}
          onChange={handleChange("title")}
        />
        <Input
          smallTitle="한줄평"
          placeholder="내용을 입력해 주세요"
          value={terms.comment}
          onChange={handleChange("comment")}
        />
      </form>

      <label htmlFor="">별점</label>
      <select
        style={{ display: "block" }}
        value={terms.score}
        onChange={handleChange("score")}
      >
        {options.map((option) => (
          <option key={option.id} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <button onClick={handleSubmit} className="addBtn">
        등록
      </button>
    </section>
  );
};

export default AddReview;
